(function (root, factory) {
  'use strict';

  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (!root || !root.document) return;

  root.LTInquiryDatePolicy = api;

  function initialize() {
    api.apply(root.document, new Date());
  }

  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  root.document.addEventListener('shopify:section:load', initialize);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function browserLocalDate(date) {
    return [
      date.getFullYear(),
      pad(date.getMonth() + 1),
      pad(date.getDate())
    ].join('-');
  }

  function isCalendarDate(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match) return false;

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var candidate = new Date(year, month - 1, day, 12, 0, 0);

    return candidate.getFullYear() === year &&
      candidate.getMonth() === month - 1 &&
      candidate.getDate() === day;
  }

  function classify(value, now) {
    if (!value) return 'empty';
    if (!isCalendarDate(value)) return 'malformed';
    return value < browserLocalDate(now) ? 'past' : 'allowed';
  }

  function validate(field, now) {
    var result = classify(field.value, now);
    var advisory = field.ownerDocument && field.dataset.ltDateAdvisoryTarget
      ? field.ownerDocument.getElementById(field.dataset.ltDateAdvisoryTarget)
      : null;
    field.removeAttribute('min');
    field.setCustomValidity('');
    field.dataset.ltDateClassification = result;
    if (advisory) {
      if (result === 'past') {
        advisory.textContent = 'This date is before today in your browser. You can still submit it.';
      } else if (result === 'malformed') {
        advisory.textContent = 'Check the date format. You can still submit the form after the browser accepts a date.';
      } else {
        advisory.textContent = '';
      }
    }
    return result;
  }

  function apply(documentRoot, now) {
    var fields = documentRoot.querySelectorAll('[data-lt-event-date]');

    fields.forEach(function (field) {
      field.removeAttribute('min');
      field.dataset.ltDatePolicy = 'browser-local-advisory-v1';
      validate(field, now);

      if (field.dataset.ltDatePolicyBound === 'true') return;
      field.dataset.ltDatePolicyBound = 'true';

      field.addEventListener('input', function () {
        validate(field, new Date());
      });
      field.addEventListener('change', function () {
        validate(field, new Date());
      });

      if (field.form && field.form.dataset.ltDatePolicyBound !== 'true') {
        field.form.dataset.ltDatePolicyBound = 'true';
        field.form.addEventListener('submit', function () {
          var current = new Date();
          validate(field, current);
        });
      }
    });

    return fields.length;
  }

  return {
    apply: apply,
    browserLocalDate: browserLocalDate,
    classify: classify,
    isCalendarDate: isCalendarDate,
    validate: validate
  };
});
